import { render } from "./company.vue?vue&type=template&id=496d0755"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"

import "./company.vue?vue&type=style&index=0&id=496d0755&lang=css"
script.render = render

export default script